<simple-toast />
<div class="content">
	@if (isAuthenticated()) {
		<ic-app-alert-banner />
	}
	<section class="page">
		<router-outlet />
	</section>
</div>
